function initProductSwiper() {
    const root = document.querySelector('[data-product-swiper]');

    if (!root) {
        return;
    }

    const pagination = root.querySelector('[data-product-swiper-pagination]');

    if (!pagination) {
        return;
    }

    let swiper = null;
    const desktopQuery = window.matchMedia('(min-width: 1024px)');

    const destroySwiper = () => {
        if (swiper) {
            swiper.destroy(true, true);
            swiper = null;
        }
    };

    const setupSwiper = () => {
        if (desktopQuery.matches) {
            destroySwiper();
            return;
        }

        if (swiper) {
            return;
        }

        swiper = new Swiper(root, {
            slidesPerView: 1,
            spaceBetween: 16,
            speed: 500,
            pagination: {
                el: pagination,
                clickable: false,
            },
        });
    };

    setupSwiper();
    desktopQuery.addEventListener('change', setupSwiper);
}

initProductSwiper();

function initVideosOnView() {
    const videos = document.querySelectorAll('[data-video-on-view]');

    if (!videos.length) {
        return;
    }

    const observer = new IntersectionObserver(
        (entries) => {
            entries.forEach((entry) => {
                const video = entry.target;

                if (!(video instanceof HTMLVideoElement)) {
                    return;
                }

                if (entry.isIntersecting) {
                    video.play().catch(() => undefined);
                } else {
                    video.pause();
                }
            });
        },
        { threshold: 0.4 },
    );

    videos.forEach((video) => {
        video.preload = 'metadata';
        observer.observe(video);
    });
}

initVideosOnView();

// function initAccordions() {
//     const accordions = document.querySelectorAll('[data-accordion]');

//     if (!accordions.length) {
//         return;
//     }

//     accordions.forEach((accordion) => {
//         const items = Array.from(
//             accordion.querySelectorAll('[data-accordion-item]'),
//         );

//         if (!items.length) {
//             return;
//         }

//         const openItem = (item) => {
//             const panel = item.querySelector('[data-accordion-panel]');
//             const trigger = item.querySelector('[data-accordion-trigger]');
//             const icon = item.querySelector('[data-accordion-icon]');

//             if (panel) {
//                 panel.classList.remove('hidden');
//                 panel.style.maxHeight = `${panel.scrollHeight}px`;
//             }
//             trigger?.setAttribute('aria-expanded', 'true');
//             panel?.setAttribute('aria-hidden', 'false');
//             icon?.classList.add('rotate-180');
//         };

//         const closeItem = (item) => {
//             const panel = item.querySelector('[data-accordion-panel]');
//             const trigger = item.querySelector('[data-accordion-trigger]');
//             const icon = item.querySelector('[data-accordion-icon]');

//             if (panel) {
//                 panel.style.maxHeight = '0px';
//             }
//             trigger?.setAttribute('aria-expanded', 'false');
//             panel?.setAttribute('aria-hidden', 'true');
//             icon?.classList.remove('rotate-180');
//         };

//         items.forEach((item) => {
//             const trigger = item.querySelector('[data-accordion-trigger]');
//             if (!trigger) {
//                 return;
//             }

//             trigger.addEventListener('click', () => {
//                 const isOpen = trigger.getAttribute('aria-expanded') === 'true';

//                 if (isOpen) {
//                     closeItem(item);
//                     return;
//                 }

//                 items.forEach((other) => {
//                     if (other !== item) {
//                         closeItem(other);
//                     }
//                 });
//                 openItem(item);
//             });
//         });

//         window.addEventListener('resize', () => {
//             items.forEach((item) => {
//                 const trigger = item.querySelector('[data-accordion-trigger]');
//                 const panel = item.querySelector('[data-accordion-panel]');

//                 if (!trigger || !panel) {
//                     return;
//                 }

//                 if (trigger.getAttribute('aria-expanded') === 'true') {
//                     panel.style.maxHeight = `${panel.scrollHeight}px`;
//                 }
//             });
//         });
//     });
// }

// initAccordions();
